var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"test-result"},[_c('b-icon',{attrs:{"icon":_vm.icon,"type":_vm.iconType}}),(_vm.count != null && _vm.show)?_c('b',{staticClass:"test-result-count"},[_vm._v(_vm._s(_vm.count))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }